import { Link } from 'react-router-dom';
import { ExternalLinkIcon } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import i18n, { getDateFormatOptions } from '@/utils/i18n';
import { Routes } from '@/utils/routes';
import { ILocationReturnOrder } from './ContainerPage';

const formatDate = (value: string) =>
  new Date(value).toLocaleDateString(
    i18n.language,
    getDateFormatOptions(true, undefined, undefined, true),
  );

const LocationReturnOrders = ({
  returnOrders,
}: {
  returnOrders: ILocationReturnOrder[];
}) => {
  if (returnOrders.length === 0) return null;
  return (
    <div className="tw:mb-3 tw:flex tw:flex-col tw:gap-2">
      {returnOrders.map((returnOrder) => (
        <div
          key={`${returnOrder.merchantOrderId}-${returnOrder.addedAt}`}
          className="tw:flex tw:flex-wrap tw:items-center tw:gap-2 tw:text-sm"
        >
          <Button variant="outline" size="sm" asChild>
            <Link to={Routes.orderDetails(returnOrder.merchantOrderId)}>
              <ExternalLinkIcon className="tw:size-4 tw:shrink-0 tw:text-muted-foreground" />
              <span>
                {i18n.t('Containers:returnOrderLink', {
                  deliveryNoteId: returnOrder.deliveryNoteId,
                })}
              </span>
            </Link>
          </Button>
          <Badge variant="secondary">
            {i18n.t(`Containers:returnOrderSource_${returnOrder.source}`)}
          </Badge>
          <span className="tw:text-muted-foreground">
            {i18n.t('Containers:returnOrderInTransitSince', {
              date: formatDate(returnOrder.addedAt),
            })}
          </span>
          {returnOrder.removedAt && returnOrder.removalReason && (
            <span className="tw:text-muted-foreground">
              {i18n.t(
                `Containers:returnOrderRemoved_${returnOrder.removalReason}`,
                { date: formatDate(returnOrder.removedAt) },
              )}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default LocationReturnOrders;
